export default "__VITE_ASSET__c6eb941b__"